export const colorMap = {
  pink: 'rgba(255, 90, 132, ',
  blue: 'rgba(136, 165, 245, ',
  green: 'rgba(123, 200, 177, ',
  purple: 'rgba(163, 126, 210, ',
} as const;

export type Colors = keyof typeof colorMap;

export type Sizes = 'large' | 'medium' | 'small';
